import PropTypes from "prop-types"
import { Skeleton } from "@mui/material"
import DynamicEllipsisWithTooltip from "components/dynamic-ellipsis-with-tooltip"
import { RULES } from "connected-components/compare/position-sets"
import { DELTA_SYMBOL } from "helpers/assets/constants"
import "./styles.scss"

function InstrumentContent({ instrument }) {
  if (!instrument) return null

  // Use displayName (which includes proper formatting) or fallback to name
  return instrument.displayName || instrument.name || "Unknown"
}

InstrumentContent.propTypes = {
  instrument: PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    tag: PropTypes.string,
    isLoading: PropTypes.bool,
  }),
}

function Instrument({ instrument, className }) {
  if (!instrument) return null

  let content
  // Don't wrap loading spinner in tooltip - render directly
  if (instrument.isLoading && instrument.tag) {
    content = <Skeleton className="instrument-loading" />
  // Only use tooltip for non-loading content
  } else {
    content = (
      <DynamicEllipsisWithTooltip>
        <InstrumentContent instrument={instrument} />
      </DynamicEllipsisWithTooltip>
    )
  }

  return (
    <div className={className}>
      {content}
    </div>
  )
}

Instrument.propTypes = {
  instrument: PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    tag: PropTypes.string,
    isLoading: PropTypes.bool,
  }),
  className: PropTypes.string,
}

export default function Header({ instruments = [] }) {
  const [first, second] = instruments ?? []

  return (
    <div className="position-sets-header">
      <div />
      <Instrument instrument={first} className="first instrument" />
      {second && <Instrument instrument={second} className="second instrument" />}
      {first && second && <div className="third instrument">
        <DynamicEllipsisWithTooltip>{second.type === RULES ? "Sizing" : DELTA_SYMBOL}</DynamicEllipsisWithTooltip>
      </div>}
    </div>
  )
}

Header.propTypes = {
  instruments: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    tag: PropTypes.string,
    isLoading: PropTypes.bool,
  })).isRequired,
}
